import type { StatusLevel } from "../components/StatusBadge";
import type { UseAlertsResult } from "../hooks/useAlerts";

export interface AlertStatus {
  level: StatusLevel;
  label?: string;
  detail: string;
}

/**
 * The top-bar verdict from the alert queue. ALL CLEAR is only allowed when the
 * engine is reachable, running, and has evaluated at least once with nothing
 * open — anything less is "unknown", never a reassuring green.
 */
export function deriveAlertStatus(q: Pick<UseAlertsResult, "tier" | "engine" | "summary">): AlertStatus {
  if (q.tier === "loading") {
    return { level: "unknown", detail: "Loading the alert queue" };
  }
  if (q.tier === "unavailable" || !q.engine || q.engine.running === false) {
    return { level: "unknown", label: "ALERTS OFFLINE", detail: "The alert engine is unreachable — the campus state is unknown, not clear" };
  }
  const { total, highest, bySeverity } = q.summary;
  if (total === 0) {
    if (!q.engine.lastEvaluatedAt) return { level: "unknown", detail: "Alert engine started; first evaluation pending" };
    return { level: "clear", detail: "No open alerts from any rule" };
  }
  const level: StatusLevel = highest === "critical" || highest === "warning" ? highest : "watch";
  return {
    level,
    detail: `${bySeverity.critical} critical, ${bySeverity.warning} warning, ${bySeverity.watch + bySeverity.info} watch — see the attention queue`,
  };
}
